import { Component } from "@angular/core";
import { NgxSkeletonLoaderComponent } from "ngx-skeleton-loader";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  imports: [
    NgxSkeletonLoaderComponent,
    NgTemplateOutlet
  ],
  selector: "wcg-s-document-type-skeleton-loader",
  template: `
<!--    grid grid-cols-[5%_50%_50%] px-6 py-4 hover:bg-gray-50 transition-colors-->
<!--text-gray-900 col-span-1 py-4-->
<div class="divide-y divide-gray-200">
    @for (n of [1, 2, 3, 4, 5]; track n) {

      <div
        class="grid grid-cols-[5%_50%_50%] items-center px-6 py-4 hover:bg-gray-50 transition-colors"
      >
        <div class=" col-span-1 py-4">
          <ng-container [ngTemplateOutlet]="loader" [ngTemplateOutletContext]="{
          props:{
          appearance: 'square',
          theme: {
            width:'50px',
            height: '50px',
            borderRadius: '4px',
            }
          }
          }" />
        </div>
        <div class="py-4 mt-4">
          <ng-container [ngTemplateOutlet]="loader" [ngTemplateOutletContext]="{
          props:{
          appearance: 'line',
          theme: {
            width:'50%',
            height: '25px',
            borderRadius: '5px',
            }
          }
          }" />
        </div>
        <div class="py-4 mt-4">
          <ng-container [ngTemplateOutlet]="loader" [ngTemplateOutletContext]="{
          props:{
          appearance: 'line',
          theme: {
            width:'50%',
            height: '25px',
            borderRadius: '5px',
            }
          }
          }" />
        </div>
      </div>
    }
</div>

    <ng-template #loader let-props='props'>
      <ngx-skeleton-loader
        [size]="props.size"
        [appearance]="props.appearance"
        [theme]="props.theme"
      />
    </ng-template>
  `
})
export class SDocumentTypeSkeletonLoaderComponent {}
